<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {
    this.int()
  },
  methods: {
    async int() {
      let version = await this.$betterwe.getAppVersion().catch(() => {})
      if (version >= 98) {
        let promise1 = this.$http.getBaseApp(
          'api/v3/WeplusData/getWeplusInfoForNoVip',
          {}
        )
        let promise2 = this.$http.getBaseApp(
          'api/v3/WeplusData/getUserWeplusIdentify',
          {}
        )
        Promise.all([promise1, promise2])
          .then((arr) => {
            let [res1, res2] = arr
            res1 = res1.data
            res2 = res2.data
            if (res1.code == 200 && res2.code == 200) {
              let queState = res1.data.config.general_que_state
              let vipInfo = res2.data
              let resultRoute =
                res1.data.user_info.result_route ||
                res1.data.user_info.test_route
              let cardTypeAttr = res1.data.config.card_type_attr
              let vipTypeId = res1.data.config.vip_type_id
              this.equity_list = res1.data.equity_list
              this.jumpPage(
                vipInfo,
                queState,
                resultRoute,
                cardTypeAttr,
                vipTypeId
              )
            } else {
              this.$toast('接口异常错误')
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        this.bindBack()
      }
    },
    jumpPage(vipInfo, queState, resultRoute, cardTypeAttr, vipTypeId) {
      //新人问卷状态 : 0-已过期,1-未领取 2-已领取待使用，3-已使用',
      if (queState == 3) {
        if (vipInfo.is_old_weplus) {
          /* 用户已使用新人问卷且是老版会员 */
          this.bindBack()
        } else if (vipInfo.is_weplus) {
          /* 用户已使用新人问卷且是新版会员 则给出提示  */
          this.bindBack()
        } else {
          /* 去购买详情页 */
          this.jumpOrderDetail()
        }
      } else if (queState == 2) {
        if (vipInfo.is_old_weplus) {
          /* 用户已领取待使用且是老版会员*/
          this.bindBack()
        } else if (vipInfo.is_weplus) {
          this.bindBack()
        } else {
          /* 去填写问卷 */
          this.$dialog
            .confirm({
              title: '提示',
              message: '您未进行体质评估，是否开启测评？'
            })
            .then(() => {
              this.$router.go(-1)
              this.$betterwe.jumpRoute(resultRoute)
              //  this.$router.replace("/newcomer-questionnaire-v2/result?id=" + id);
            })
            .catch(() => {
              /* 去购买详情页 */
              this.jumpOrderDetail()
            })
        }
      } else {
        if (vipInfo.is_old_weplus) {
          /* 用户未领取新人问卷且是老版会员 */
          this.bindBack()
        } else if (vipInfo.is_weplus) {
          this.bindBack()
        } else {
          /* 去填写问卷 */
          this.$dialog
            .confirm({
              title: '提示',
              message: '您未进行体质评估，是否开启测评？'
            })
            .then(() => {
              this.receiveQue()
            })
            .catch(() => {
              /* 去购买详情页 */
              this.jumpOrderDetail()
            })
        }
      }
    },
    /* 领取新人问卷 */
    receiveQue() {
      this.$http
        .getBaseApp('/member/AppCamp/receiveComerQue', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.getVipData()
          } else {
            this.$toast(res.msg)
          }
        })
    },
    getVipData() {
      this.$http
        .getBaseApp('api/v3/WeplusData/getWeplusInfoForNoVip', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$router.go(-1)
            this.$betterwe.jumpRoute(
              res.data.user_info.test_route || res.data.user_info.result_route
            )
          }
        })
    },
    /* 去大会员权益页 */
    jumpVipDetail() {
      this.$router.go(-1)
      this.$betterwe.onAppPageUrlRoute('/vipUserEquity')
    },
    /* 去购买vip页 */
    jumpBuyVip(cardTypeAttr, vipTypeId) {
      this.$router.go(-1)
      this.$betterwe.vipHomePage({
        card_type_attr: cardTypeAttr,
        vip_type_id: vipTypeId
      })
    },
    bindBack() {
      this.$toast('您不符合活动条件')
      setTimeout(() => {
        this.$router.go(-1)
      }, 500)
    },
    //订单详情页
    async jumpOrderDetail() {
      let equity_list = this.equity_list
      let res = equity_list.find((item) => {
        return (
          item.type_id == 3 &&
          item.card_type_second_level ==
            +this.$route.query.card_type_second_level
        )
      })
      if (res) {
        if (res.ecshop_url) {
          let tokenData = await this.$http
            .getBaseApp('api/v3/WeplusData/getEcshopToken', {})
            .catch(() => {})
          let token = tokenData?.data?.data
          if (token) {
            let url = res.ecshop_url + '&isGetShopToken=1&isLogin=1'
            this.$betterwe.jumpRoute(url)
            this.$router.go(-1)
          } else {
            this.$toast('抱歉，海外用户暂不支持购买~')
            setTimeout(() => {
              this.$router.go(-1)
            }, 500)
          }
        } else {
          res.wmshop_url && this.$betterwe.onAppPageUrlRoute(res.wmshop_url)
        }
      } else {
        this.$toast('订单不存在')
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      }
    }
  }
}
</script>
